import { get } from './_core.js';

export interface SearchResults {
  users: Array<{ id: string; email: string; role: string }>;
  sessions: Array<{
    id: string;
    userId: string;
    userEmail: string;
    moduleId: string | null;
    startedAt: string;
  }>;
  traces: Array<{ traceId: string; spanCount: number; firstSessionId: string | null }>;
}

export async function fetchSearch(q: string): Promise<SearchResults> {
  const res = await get<SearchResults>(`/admin/search?q=${encodeURIComponent(q)}`);
  return res.data;
}
